import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkLink } from 'uitk-react-link';

export interface PriceBreakDownMenuProps {
  id: string;
  header: string;
  childContent: React.ReactNode;
}

const LinkTracked = ClickTracker(UitkLink);

export const PriceBreakDownMenu = ({ childContent, id, header }: PriceBreakDownMenuProps) => {
  const [showMenu, setShowMenu] = React.useState<boolean>(false);
  const handleClick = () => setShowMenu(!showMenu);

  if (!header || !childContent) {
    return null;
  }

  const trackingRfrr = id === 'infosite-room-ratePlans' ? 'RoomsAndRates.PriceDetail' : 'RoomInfo.PriceDetail';

  return (
    <UitkMenu id="show" isOpen={showMenu} onTriggerClick={handleClick}>
      <UitkMenuTrigger>
        <LinkTracked linkName="price.breakdown.details" rfrr={trackingRfrr}>
          <button>{header}</button>
        </LinkTracked>
      </UitkMenuTrigger>
      <UitkMenuContainer width={250} position={PositionType.RIGHT}>
        {childContent}
      </UitkMenuContainer>
    </UitkMenu>
  );
};

PriceBreakDownMenu.displayName = 'PriceBreakDownMenu';
